import React, { useState } from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Loading from '@nmx/template/dist/componentLibrary/components/Loading';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// styles
import {
  DivStyledClaimsInfoModule,
  DivStyledVideoContainer,
  LinkStyled,
  LinkStyledButton,
} from './styles';

const claimsData = {
  death: {
    headingText: 'Report a death claim',
    linkUrl: 'report-a-death',
    linkAriaLabel: 'Go to the Report a Death Claim form',
    videoSrc: 'https://www.youtube.com/embed/mamYoNgJmzU',
    videoTitle: 'What to expect when filing a death claim',
    pdfLinks: [
      {
        pdfLinkText: 'Download beneficiary checklist (pdf)',
        pdfLinkUrl: '/assets/pdf/faq/beneficiary-checklist-v2.pdf',
      },
    ],
  },
  disability: {
    headingText: 'Report a disability claim',
    linkUrl: 'notice-of-disability-form',
    linkAriaLabel: 'Go to the Disability Claim form',
    videoSrc: 'https://www.youtube.com/embed/pfsI83Y1UZY',
    videoTitle: 'What to expect when filing a disability claim',
    pdfLinks: [
      {
        pdfLinkText: 'Request for Disability Benefits form (sample)',
        pdfLinkUrl: '/assets/pdf/faq/sample-request-for-disability-benefits-form.pdf',
      },
      {
        pdfLinkText: 'Request for Waiver Benefits form (sample)',
        pdfLinkUrl: '/assets/pdf/faq/sample-request-for-waiver-benefits-form.pdf',
      },
    ],
  },
  ltc: {
    headingText: 'Report a long-term care claim',
    linkUrl: 'notice-of-long-term-care-form',
    linkAriaLabel: 'Go to the Long Term Care Claim form',
    videoSrc: 'https://www.youtube.com/embed/87A4BoGAynk?si=7aDJ5I2OZGlEkfNt',
    videoTitle: 'What to expect when filing a long-term care claim',
    pdfLinks: [
      {
        pdfLinkGroupHeading: 'Getting Started',
        pdfLinkText: 'Navigating the LTC claims process (pdf)',
        pdfLinkUrl: '/assets/pdf/claims/navigating-the-ltc-claims-process.pdf',
      },
      {
        pdfLinkText: 'Download Authorization to Discuss (pdf)',
        pdfLinkUrl: '/assets/pdf/claims/authorization-to-discuss-ltc-claim-information.pdf',
      },
      {
        pdfLinkText: 'Download Authorization to Obtain and Disclose (pdf)',
        pdfLinkUrl: '/assets/pdf/claims/authorization-to-obtain-and-disclose-information.pdf',
      },
      {
        pdfLinkGroupHeading: 'Common Questions',
        pdfLinkText: 'Download qualified expenses (pdf)',
        pdfLinkUrl: '/assets/pdf/claims/qualified_expenses.pdf',
      },
      {
        pdfLinkText: 'Download appropriate providers of care (pdf)',
        pdfLinkUrl: '/assets/pdf/claims/appropriate_providers_of_care.pdf',
      },
      {
        pdfLinkText: 'Download when your care needs change while on claim (pdf)',
        pdfLinkUrl: '/assets/pdf/claims/when_your_care_needs_change_while_on_claim.pdf',
      },
      {
        pdfLinkGroupHeading: 'Other Forms',
        pdfLinkText: 'Download Provider Change Request (pdf)',
        pdfLinkUrl: '/assets/pdf/claims/provider-change-request.pdf',
      },
      {
        pdfLinkText: 'Download Independent Provider Professional History (pdf)',
        pdfLinkUrl: '/assets/pdf/claims/independent-provider-professional-history.pdf',
      },
      {
        pdfLinkText: 'Download EFT Authorization to Download Electronic Funds Transfer Authorization (pdf)',
        pdfLinkUrl: '/assets/pdf/claims/eft-authorization-active.pdf',
      },
      {
        pdfLinkText: 'Download COB Other Coverage to Download Coordination of Benefits Other Coverage (pdf)',
        pdfLinkUrl: '/assets/pdf/claims/cob-other-coverage-insured.pdf',
      },
      {
        pdfLinkText: 'Download Assignment of Benefits Letter and Form (pdf)',
        pdfLinkUrl: '/assets/pdf/claims/assignment-of-benefits-letter-and-form.pdf',
      },
      {
        pdfLinkText: 'Download Authorization HIPAA (pdf)',
        pdfLinkUrl: '/assets/pdf/claims/authorization-hipaa.pdf',
      },
    ],
    disclaimer: <>
      <Typography
        component='span'
        weight={500}>Important:</Typography> To protect your confidential information, please be sure to use our email encryption service if you send us your completed claim forms by email. This service can be accessed from the secure email link we sent you. Don&#39;t have the link&#63; Please contact us and we will send it to you.
    </>,
  },
};

export default ({ dataOption }) => {
  const [iframeHasLoaded, setIframeHasLoaded] = useState(false);

  const hideLoadingIcon = () => {
    setIframeHasLoaded(true);
  };
  return (
    <DivStyledClaimsInfoModule>
      <Row align='center'>
        <Col align='center'>
          <Typography
            component='h3'
            align='center'
            nextElement='button'>
            {claimsData[dataOption].headingText}
          </Typography>
          <LinkStyledButton
            linkUrl={`/${claimsData[dataOption].linkUrl}/`}
            variant='buttonLinkPrimary'
            themeType='lightTheme'>
            Get started
          </LinkStyledButton>
        </Col>
        <Col medium={11}>
          <Typography nextElement='graphic'>
            See what you can expect during the claims process:
          </Typography>
          <DivStyledVideoContainer>
            {!iframeHasLoaded && (
              <Row align='center'>
                <Col>
                  <Loading />
                </Col>
              </Row>
            )}
            <iframe
              width='600'
              height='320'
              src={claimsData[dataOption].videoSrc}
              title={claimsData[dataOption].videoTitle}
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; enablejsapi;'
              allowFullScreen
              onLoad={hideLoadingIcon}
            />
          </DivStyledVideoContainer>
          {claimsData[dataOption].pdfLinks && (
            claimsData[dataOption].pdfLinks.map((item, index) => (
              <span key={`${claimsData[dataOption].linkUrl}-${index + 1}`}>
                {item.pdfLinkGroupHeading && (
                  <Typography
                    component='h3'
                    nextElement='link'>
                    {item.pdfLinkGroupHeading}
                  </Typography>
                )}
                <LinkStyled
                  linkUrl={item.pdfLinkUrl}
                  variant='primaryDeemphasize'
                  themeType='lightTheme'
                  isInternalPdf
                  endAdornment={CaratRight}
                  endAdornmentStylesReset>
                  {item.pdfLinkText}
                </LinkStyled>
              </span>
            ))
          )}
          {claimsData[dataOption].disclaimer && (
            <Typography
              component='small'
              disableBottomPadding>
              {claimsData[dataOption].disclaimer}
            </Typography>
          )}
        </Col>
      </Row>
    </DivStyledClaimsInfoModule>
  );
};
